import React, { useState, useEffect } from 'react';
import config from 'react-global-configuration';
import { Field } from 'formik';
import i18next from '../../config/i18next';

import {
  WysiwygField,
} from '..';

const WebformPostcodeAddressAutocomplete = (props) => {
  const { entity, setFieldValue, errors, touched } = props;
  const API_URL = config.get('API_URL');
  const title = entity.get('#title');
  const webformKey = entity.get('#webform_key');
  const required = entity.get('#required');
  const requiredError = entity.get('#required_error');
  const description = entity.get('#description');
  const [addressNumber, setAddressNumber] = useState(null);
  const [addressPostcode, setAddressPostcode] = useState(null);
  const [results, setResults] = useState([]);

  function validation(value) {
    let error;
    if (required && !value) {
      error = requiredError || 'Dit is een vereist veld.';
    }
    return error;
  }

  useEffect(() => {
    const getSuggestions = () => {
      const url = `${API_URL}/api/postcode-address-autocomplete?q=${addressPostcode}`;
      fetch(url)
        .then((response) => { return response.json(); })
        .then((response) => {
          const ajaxResults = response.map((item, index) => {
            item.value = index;
            return item;
          });
          setResults(ajaxResults);
        });
    };

    if (addressNumber && addressPostcode) {
      const match = addressPostcode.match(/^\d{4}\s?[a-zA-Z]{2}$/g);
      if (match && match.length === 1) {
        getSuggestions();
      }
    }
  }, [addressNumber, addressPostcode, API_URL]);

  useEffect(() => {
    const setValue = (item) => {
      const value = {
        address_line1: `${results[0].straatnaam} ${addressNumber}`, // Straatnaam + nummer
        address_line2: '',
        postal_code: addressPostcode, // Postcode
        locality: results[0].woonplaats, // Plaats
        dependent_locality: '',
        administrative_area: '',
        country_code: 'NL',
      };
      setFieldValue(webformKey, value);
    };

    if (results[0]) {
      setValue();
    }
  }, [addressNumber, addressPostcode, results, setFieldValue, webformKey, API_URL]);


  return (
    <div className="WebformAddress">
      {title && <label htmlFor={webformKey}>{title}{!required && ' (optioneel)'}</label>}
      <Field name={webformKey} validate={validation}>
        {({ field, form }) => {
          return (
            <input
              {...field}
              type="hidden"
            />
          );
        }}
      </Field>

      <div className="row">
        <div className="col-md-3 col-sm-8">
          <label htmlFor="WebformPostcodeAddressPostcode">{i18next.t('webform_postcode')}</label>
          <input type="text" name="WebformPostcodeAddressPostcode" onChange={(e) => { setAddressPostcode(e.target.value); }} id="WebformPostcodeAddressPostcode" />
        </div>
        <div className="col-md-2 col-sm-4">
          <label htmlFor="WebformPostcodeAddressNumber">{i18next.t('webform_number')}</label>
          <input type="text" name="WebformPostcodeAddressNumber" onChange={(e) => { setAddressNumber(e.target.value); }} id="WebformPostcodeAddressNumber" />
        </div>
        <div className="col-md-7 col-sm-12">
          <label htmlFor="WebformPostcodeAddressLocality">{i18next.t('webform_locality')}</label>
          <input disabled type="text" name="WebformPostcodeAddressLocality" value={results && results[0] && results[0].woonplaats ? results[0].woonplaats : ''} id="WebformPostcodeAddressLocality" />
        </div>
        <div className="col-sm-12  mt-4">
          <label htmlFor="WebformPostcodeAddressResult">{i18next.t('webform_streetname')}</label>
          <input type="text" disabled name="WebformPostcodeAddressResult" value={results && results[0] && results[0].straatnaam ? results[0].straatnaam : ''} id="WebformPostcodeAddressResult" />
        </div>
      </div>

      <div className="row">
        { description && (
          <WysiwygField
            property="schema:text"
            html={description}
            className="col-12 WebformAddressAutocomplete__description WebformComponent--description" />
        )}
      </div>
      {errors[webformKey] && touched[webformKey] ? <div className="WebformRadio_error WebformComponent--error">{errors[webformKey]}</div> : null}
    </div>
  );
};

export default WebformPostcodeAddressAutocomplete;
